import React from "react";
import { useNavigate } from "react-router-dom";
export default function ShippingPolicy() {
  const pageWrapperStyle = {
    minHeight: "100vh",
    padding: "7rem 0.75rem",
    backgroundColor: "#f9fafb",
    fontFamily: "'Inter', sans-serif",
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    maxWidth: "1024px",
    margin: "0 auto",
    padding: "2.5rem",
    borderRadius: "1rem",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 10px rgba(0, 0, 0, 0.05)",
  };

  const titleStyle = {
    fontWeight: "800",
    fontSize: "2.25rem",
    textAlign: "center",
    marginBottom: "2.5rem",
    color: "#991b1b", // Blue for a calm/logistics theme
  };

  const sectionHeadingStyle = {
    fontSize: "1.5rem",
    fontWeight: "700",
    marginTop: "2rem",
    marginBottom: "1rem",
    color: "#1f2937",
    borderBottom: "2px solid #991b1b", // Blue accent
    paddingBottom: "0.5rem",
  };

  const subHeadingStyle = {
    fontSize: "1.125rem", // text-lg
    fontWeight: "600",
    marginTop: "1.5rem",
    marginBottom: "0.75rem",
    color: "#1f2937",
  };

  const textStyle = {
    fontSize: "1rem",
    lineHeight: "1.625",
    color: "#4b5563",
    marginBottom: "1.5rem",
  };

  const listStyle = {
    listStyleType: 'disc',
    paddingLeft: '1.25rem',
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
  };

  const infoBoxStyle = {
    backgroundColor: "#eff6ff",
    borderLeft: "4px solid #991b1b",
    color: "#991b1b",
    padding: "1rem",
    borderRadius: "0.5rem",
    marginTop: "0.75rem",
  };

  const warningBoxStyle = {
    backgroundColor: "#fef2f2",
    borderLeft: "4px solid #ef4444",
    color: "#991b1b",
    padding: "1rem",
    borderRadius: "0.5rem",
    marginTop: "1rem",
  };

  const linkStyle = {
    color: "#991b1b",
    textDecoration: "none",
    fontWeight: "600",
  };
  
  const buttonContainerStyle = {
    textAlign: "center",
    marginTop: "2.5rem",
  };

  const buttonStyle = {
    backgroundColor: "#991b1b",
    color: "white",
    fontWeight: "600",
    padding: "0.75rem 2rem",
    borderRadius: "9999px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    border: 'none',
    cursor: 'pointer',
  };
  const navigate = useNavigate();


  return (
    <div style={pageWrapperStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>
          Domestic & International Shipping Policy
        </h2>

        {/* Section 1: Contact and Hours */}
        <div>
          <h3 style={sectionHeadingStyle}>
            1. Customer Care & Communication
          </h3>
          <div style={textStyle}>
            <p style={{...textStyle, marginBottom: '0'}}>Our team is available to assist you during the following hours:</p>
            <p style={{ fontWeight: "700", marginBottom: '0.25rem', marginTop: '0.5rem' }}>Office Hours: Monday to Saturday (10:00 AM - 2:00 PM and 3:00 PM - 6:00 PM IST)</p>
            <p style={{ ...textStyle, fontWeight: "700", marginTop: "0.5rem", marginBottom: '0.5rem' }}>Customer Care Number: 9082826596</p>
            <p style={infoBoxStyle}>
              We will assist you with your queries during our working hours. If you call during non-working hours, we will revert the next day if bandwidth permits, or we request you to call us again during our operational time for immediate assistance.
            </p>
            <p style={warningBoxStyle}>
              Important Communication Policy: Kindly do not message us on the WhatsApp number used for order confirmation and tracking; that number is exclusively for marketing purposes and messages are not monitored. Please contact us via:
              <br />
              - Instagram: <a href="https://instagram.com/elite_clothings_hyd" target="_blank" rel="noopener noreferrer" style={linkStyle}>@elite_clothings_hyd</a>
              <br />
              - Email: <a href="mailto:support@eliteclothings.in" style={linkStyle}>support@eliteclothings.in</a>
            </p>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            2. Order Processing and Dispatch
          </h3>
          <div style={textStyle}>
            <p>All orders will be dispatched within 12 hours to 3 working days of order placement.</p>

            <h4 style={subHeadingStyle}>Delivery Timelines (After Dispatch):</h4>
            <ul style={listStyle}>
              <li style={listItemStyle}>Telangana: 1 – 3 days</li>
              <li style={listItemStyle}>South India: 3 – 6 days</li>
              <li style={listItemStyle}>North India: 5 – 8 days</li>
              <li style={listItemStyle}>Special/Border Locations: 6 – 15 days</li>
            </ul>

            <h4 style={subHeadingStyle}>Express Dispatch (Same Day):</h4>
            <p>If you require express dispatch, kindly mention "URGENT" in your order notes. The order will be dispatched on the Same day if placed before 3 PM or the next working day. You must also call and inform our customer care during working hours for immediate action.</p>

            <h4 style={subHeadingStyle}>Express Delivery:</h4>
            <p>Express delivery includes first priority and same-day dispatch (if ordered before 3 PM). Additional shipping charges are applicable and must be informed to and confirmed by our customer care prior to dispatch. If the order is already dispatched, it cannot be converted to express shipping.</p>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            3. Order Communication and Tracking
          </h3>
          <div style={textStyle}>
            <ul style={listStyle}>
              <li style={listItemStyle}>We will keep you posted about your order confirmation and tracking number through both email and WhatsApp.</li>
              <li style={listItemStyle}>The shipment tracking details, including your name and the delivery partner, will be sent to your email & WhatsApp.</li>
              <li style={listItemStyle}>Tracking details are usually updated roughly within 2 hours of dispatch.</li>
            </ul>

            <h4 style={subHeadingStyle}>Stock Issues:</h4>
            <p>If any size or color is out of stock upon order confirmation, we will inform you within 1 – 5 working days and suggest a similar color/print before dispatching. We will let you know if the item is restockable or non-restockable so you can choose accordingly.</p>

            <h4 style={subHeadingStyle}>Default Courier Partners by State:</h4>
            <ul style={listStyle}>
              <li style={listItemStyle}>Telangana: ST Courier Services</li>
              <li style={listItemStyle}>Kerala: Delhivery / DTDC / Indian Post</li>
              <li style={listItemStyle}>Karnataka, Andhra Pradesh: DTDC / Delhivery (based on pincode serviceability)</li>
              <li style={listItemStyle}>Tamil Nadu: ST Courier Services</li>
              <li style={listItemStyle}>North India: Delhivery / DTDC / Indian Post</li>
            </ul>
            <p style={{...textStyle, marginTop: '1rem'}}>
              On any special request, we can ship on any courier company of your choice. This request must be written on your order note before checkout.
            </p>
          </div>
        </div>

        <div>
          <h3 style={sectionHeadingStyle}>
            4. Delays, RTO (Return to Origin), and Lost Parcels
          </h3>
          <div style={textStyle}>
            <p>Shipping is a third-party service. Delays may occur during public holidays, natural calamities, or strikes. While the management is not liable for such delays, we will actively help you track your package.</p>
            
            <h4 style={subHeadingStyle}>Return to Origin (RTO) - Customer Errors:</h4>
            <p>In the event of a wrong contact number, wrong, or insufficient address, the product will be returned back to us (RTO). If this happens:</p>
            <ul style={listStyle}>
              <li style={listItemStyle}>We bear the return courier charge (parcel coming back to our warehouse).</li>
              <li style={listItemStyle}>We would request you to pay the courier charge for sending the parcel again from our warehouse to your updated address.</li>
              <li style={listItemStyle}>We will give you the preference of choosing any other courier company at that time.</li>
              <li style={listItemStyle}>If we are unable to reach you via the mobile number provided, we will send an email to contact you.</li>
            </ul>
            
            <h4 style={subHeadingStyle}>Lost or Undelivered Parcels:</h4>
            <p style={warningBoxStyle}>
              In any case where the parcel is lost or not delivered by our courier partner, we will send you a new parcel and ensure it reaches you. Refund is not applicable in such cases. There might be a delay in the process due to necessary investigation.
            </p>
            <p style={{...textStyle, marginTop: '1rem'}}>
              Common reasons for non-delivery include wrong contact number, wrong pincode, customer not attending the delivery call, fake delivery reports, or courier being lost by the delivery partner. If any issue arises, please don’t panic. We will send a new parcel ASAP after an initial investigation and make sure you receive your ordered products.
            </p>
          </div>
        </div>
        
        <div>
          <h3 style={sectionHeadingStyle}>
            5. International Shipping Policy
          </h3>
          <div style={textStyle}>
            <ul style={listStyle}>
              <li style={listItemStyle}>Orders will be dispatched within 1 – 4 working days.</li>
              <li style={listItemStyle}>We will check with international partners (DHL, India Post, Aramex, DTDC International, Garudavega) and share the shipping rates and estimated shipping periods from different couriers. You can then choose a partner based on your convenience.</li>
              <li style={listItemStyle}>We will dispatch and send you the tracking number immediately after your selection.</li>
              <li style={listItemStyle}>If you are not convenient with the international shipping rate, you can send your Indian address and we will ship to your Indian address instead.</li>
            </ul>
          </div>
        </div>

        <div style={buttonContainerStyle}>
          <button
            style={buttonStyle}
            onClick={() => navigate('/')}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}